module.exports = __webpack_public_path__ + "img/stepstoparrow.dced08af.svg";